import { call } from 'redux-saga/effects';
import * as Api from '../../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../../helpers/saga';
import { fetchGuestSummaryReport as fetchGuestSummaryReportRoutine } from './routines';

export const fetchGuestSummaryReport = ({ payload: body }) =>
  sagaRoutineRequest(fetchGuestSummaryReportRoutine, {
    request: () => call(Api.fetchGuestSummaryReport, body)
  });
